// extracted by mini-css-extract-plugin
export default {"icon":"Video_icon__E0hlg"};